<template>
  <b-modal
    no-close-on-backdrop
    id="tagCreateUpdateModal"
    centered
    :visible="modalVisible"
    @close="handleClose"
    @change="handleClose"
    @cancel="handleClose"
  >
    <div class="p-1">
      <b-row
        class="d-flex flex-row justify-content-between align-items-center w-100 mb-1 mr-0 ml-0"
      >
        <span class="font-small-5">Name</span>
        <b-form-input
          id="name-field"
          v-model="name"
          class="font-small-5 w-50 text-right"
          :size="'sm'"
        />
      </b-row>
    </div>
    <template #modal-footer>
      <b-spinner
        v-if="loading"
        variant="primary"
        class="m-1"
      />
      <b-button
        v-else
        size="md"
        variant="success"
        id='buttonOK-tooltip'
        @click="save"
      >
        Save
      </b-button>
    </template>
    <template #modal-header>
      <div>
        {{ title }}
      </div>
      <b-button size="sm" class="close" variant='light'  @click="handleClose()">
        ×
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
   BRow, BCol, BFormInput, BButton, BLink, BTooltip, BSpinner
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import { secToTime } from '@/_helpers/time'
import axios from "axios";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {analysError} from "@/_helpers/analys_error";

export default {
  name: 'TagCreateUpdate',
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BButton,
    BTooltip,
    BSpinner,
  },
  props: {
    modalVisible: {
      type: Boolean,
      required: true,
    },
    tag: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      name: '',
      loading: false,
    }
  },

  computed: {
    title() {
      if (this.$props.tag !== null) {
        return 'Update Tag';
      }
      else {
        return 'Create Tag';
      }
    },
  },
  beforeMount() {
    if (this.$props.tag !== null) {
      this.name = this.$props.tag.name;
    }
  },
  methods: {
    handleClose() {
      this.name = '';
      this.$emit('closeTagCU', false);
    },
    save() {
      if (this.$props.tag === null) {
        axios.post(`${process.env.VUE_APP_API_URL}/tags`, {
            name: this.name,
          },
          {
            headers: {
              Authorization: `Bearer ${useJwt.getToken()}`,
            },
          }).then(response => {
          this.loading = false;
          this.$emit('success', true);
          this.handleClose();
        }).catch(error => {
          this.loading = false;
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: analysError(error.response),
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        })
      }
      else {
        axios.put(`${process.env.VUE_APP_API_URL}/tags/${this.$props.tag.id}`, {
            name: this.name,
          },
          {
            headers: {
              Authorization: `Bearer ${useJwt.getToken()}`,
            },
          }).then(response => {
          this.loading = false;
          this.$emit('success', true);
          this.handleClose();
        }).catch(error => {
          this.loading = false;
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: analysError(error.response),
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        })
      }
    },
  },
}
</script>

<style>
  #tooltip-button-interactive{
    cursor: pointer;
  }
</style>
